import { Box, styled, Link } from "@mui/material";
import theme from "../../theme";

const BannerStyle = styled(Box)`
  position: relative;
  z-index: 1200;
  background-color: ${theme.palette.secondaryDarker};
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0;
  @media (min-width: 768px) {
    background-color: ${theme.palette.gray};
    color: #484958;
    font-size: 16px;
    text-align: center;
  }
  .banner__content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px 16px;
    strong {
      font-family: GT-Eesti-Display-Bold, sans-serif;
      color: ${theme.palette.primary.main};
    }
    @media (min-width: 768px) {
      padding: 10px 64px 10px 16px;
    }
  }
`;

const Banner = () => {
  return (
    <BannerStyle className="banner__root">
      <div className="banner__content">
        We’ve updated eviction baselines in the ETS.{" "}
        <Link href="/new-baseline">Read more here</Link> about how that affects
        the numbers we report.
      </div>
    </BannerStyle>
  );
};

export default Banner;
